export default {
  logs: 'Logo',
}
